import Dialog from "./Dialog";
import Button from "./Button";

export default function Confirm(props) {
  const { open, onClose, title, children, onConfirm } = props;
  if (!open) {
    return <></>;
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <h2 className="text-xl">{title}</h2>
      <div className="py-5">{children}</div>
      <div className="flex justify-end">
        <div className="p-1">
          {!props.hideNo && (
            <Button
              onClick={() => onClose()}
              className="bg-red-800 hover:bg-red-600"
            >
              No
            </Button>
          )}
        </div>
        <div className="p-1">
          <Button
            onClick={() => {
              onClose();
              onConfirm();
            }}
          >
            Ok
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
